import { useState } from 'react';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import AssignWorkOrderDropDown from './AssignWorkOrderDropDown';
import Message from '../../utils/Message/Message';
import { loadingShow } from '../../App';
import {
  AddPlanOrder,
  DeletePlanOrder,
} from '../../services/ControlCenter/PlanServices';

interface IProps {
  hideDialogEventPlan: boolean;
  setHideDialogEventPlan: (cond: boolean) => void;
  theModel: PlanOrderType[];
  selectedOrders: Object[];
}

interface PlanOrderType {
  created_by: number;
  order_code: string;
  order_id: number;
  organization_Id: string;
  plan_id: number;
}

var theDataForOrderRemove: Array<any> = [];
const AssignWorkOrderDialog = ({
  selectedOrders,
  hideDialogEventPlan,
  setHideDialogEventPlan,
  theModel,
}: IProps) => {
  const [searchText, setSearchText] = useState('');
  let plandId: number = 0;
  let orderPlanModel: PlanOrderType[] = [];

  const assignOrder = async (e: any) => {
    let plan_id = localStorage.getItem('assign_plan_id_value');
    plan_id && (plandId = parseInt(plan_id));
    if (plandId > 0) {
      //loadingShow(true);

      theModel.map((item: any) => {
        const newOrderPlanModel = {
          created_by: item.created_by,
          order_code: item.order_code,
          order_id: item.order_id,
          organization_Id: item.organization_Id,
          plan_id: plandId,
        };
        orderPlanModel.push(newOrderPlanModel);
      });

      await AddPlanOrder(orderPlanModel)
        .then((res: any) => {
          Message.success('Success');
          //loadingShow(false);
          setHideDialogEventPlan(false);
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          //loadingShow(false);
        });
    } else {
      Message.error('Select a plan');
    }
  };

  const buttonsOrder: ButtonPropsModel[] = [
    {
      click: async (args: any) => {
        try {
          const planId = localStorage.getItem('assign_plan_id_value');

          const updatedOrders = selectedOrders.map((order) => ({
            ...order,
            plan_id: parseInt(planId ? planId : ''),
          }));

          await DeletePlanOrder(updatedOrders).then((res) => {
            Message.success('Deleted');
          });
        } catch (error) {
          Message.error('There is a Problem Occurred While Deleting..');
        } finally {
          setHideDialogEventPlan(false);
        }
      },
      buttonModel: {
        content: 'Delete',
        isPrimary: true,
      },
    },
    {
      click: async (args: any) => {
        await assignOrder(args);
        localStorage.setItem('assign_plan_id_value', '0');
      },
      buttonModel: {
        content: 'Assign Order',
        isPrimary: true,
      },
    },
    {
      click: () => {
        setHideDialogEventPlan(false);
      },
      buttonModel: {
        content: 'Cancel',
      },
    },
  ];

  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='work_orders_plan'
          autocomplete='off'
          showClearButton
          placeholder='Search'
          value={searchText}
          onChange={(args: any) => {
            setSearchText(args.target.value);
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        ></div>
      </div>
    );
  };

  const openDialogOrder = () => {
    // setState({ setHideDialogEventPlan: true });
  };
  const closeDialogOrder = () => {
    setHideDialogEventPlan(false);
  };

  return (
    <DialogComponent
      isModal={true}
      id='defaultdialogControlCenterPlanOrder'
      showCloseIcon={true}
      visible={hideDialogEventPlan}
      header='Assign Work Orders'
      buttons={buttonsOrder}
      open={openDialogOrder}
      close={closeDialogOrder}
      created={() => {}}
      width={500}
      height={(window.innerHeight * 20) / 100}
    >
      <div className='plan-grid-3'>
        <AssignWorkOrderDropDown theModel={theModel} />
      </div>
    </DialogComponent>
  );
};

export default AssignWorkOrderDialog;
